import React from 'react';

export const ClientLayout: React.FC = ({ children }) => (
    <>
        <div style={{ display: 'none' }} data-test-id="client-layout"></div>
        {children}
    </>
);
